
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/learn/alphabet",
      function () {
        return require("private-next-pages/learn/alphabet.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/learn/alphabet"])
      });
    }
  